import moment from 'moment';

export const daysLeftInCycle = () => {
  const cycleEndDate = 4;
  const today = moment().date();
  const lastDay = moment().date(cycleEndDate);
  today > cycleEndDate && lastDay.add(1, 'month');
  const daysLeft = moment.duration(lastDay.diff(moment())).asDays();
  return Math.ceil(daysLeft);
}

export const daysLeftInCycleCombine = ({
  attSubs,
  quickSubs,
}) => {
  // no subs
  if (!attSubs.length && !quickSubs.length) {
    return null;
  }
  // both carriers or multiple quick subs
  if ((attSubs.length && quickSubs.length) || quickSubs.length > 1) {
    return null;
  }

  let cycleEndDate;
  if (attSubs.length) {
    cycleEndDate = 4;
  } else {
    if (quickSubs[0].renew_at) {
      const date = new Date(quickSubs[0].renew_at);
      cycleEndDate = date.getDate();
    } else {
      return null
    }
  }

  const today = moment().date();
  const lastDay = moment().date(cycleEndDate);
  today > cycleEndDate && lastDay.add(1, 'month');
  const daysLeft = moment.duration(lastDay.diff(moment())).asDays();
  return Math.ceil(daysLeft);
}
